// extracted by mini-css-extract-plugin
export default {"radio":"AbstractProductEditStep7_radio__egidq"};